import {
	BooleanInput,
	Edit,
	ImageField,
	ImageInput,
	NumberInput,
	ReferenceArrayInput,
	SelectArrayInput,
	SimpleForm,
	TextField,
	TextInput,
	useRecordContext,
} from 'react-admin';
import AudioUploadComponent from './AudioUploadComponent';

// Reads the record from the Edit context (not useEditController() outside <Edit>, which would fetch
// GET /podcasts/:id — the member route — and bounce the admin back with "element not found").
const AudioUploadField = () => {
	const record = useRecordContext();
	return record?._id ? <AudioUploadComponent podcastId={String(record._id)} /> : null;
};

const PodcastEdit = () => {
	return (
		<Edit resource="podcasts/admin" mutationMode="pessimistic" redirect="/podcasts">
			<SimpleForm>
				<TextField source="id" />
				<TextInput source="title" label="שם" dir="rtl" style={{ direction: 'rtl' }} fullWidth />
				<TextInput source="sub_title" label="תת כותרת (מרצה)" dir="rtl" style={{ direction: 'rtl' }} fullWidth />
				<TextInput source="description" label="תיאור" fullWidth multiline />
				<TextInput source="audioUrl" label="קובץ אודיו (מפתח ב-S3)" fullWidth dir="ltr" />
				<NumberInput source="duration" label="אורך (שניות)" fullWidth />
				<AudioUploadField />
				<ImageField source="thumbnailUrl" label="תמונה נוכחית" />
				<ImageInput source="picture" label="תמונה">
					<ImageField source="src" />
				</ImageInput>
				<ReferenceArrayInput reference="vod/categories/all" source="category" filter={{ type: 'podcast', visible: true }} perPage={500}>
					<SelectArrayInput optionText={'hebrew_name'} label="קטגוריית פודקאסט" />
				</ReferenceArrayInput>
				<NumberInput source="priority" label="קדימות" fullWidth />
				<BooleanInput source="visible" label="זמין" fullWidth />
				<BooleanInput source="is_global" label="פודקאסט גלובלי" fullWidth />
			</SimpleForm>
		</Edit>
	);
};

export default PodcastEdit;
